import browser from 'browser-detect';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { DeptLoginService } from '../service/Dept_Login_service';
import { environment as env } from '../../environments/environment';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';



import {
  authLogin,
  authLogout,
  routeAnimations,
  LocalStorageService,
  selectIsAuthenticated,
  selectSettingsStickyHeader,
  selectSettingsLanguage,
  selectEffectiveTheme
} from '../core/core.module';
import {
  actionSettingsChangeAnimationsPageDisabled,
  actionSettingsChangeLanguage
} from '../core/settings/settings.actions';
import { AuthenticationService } from '../service/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesModel } from '../model/FormsEntity/serviceModel';
import { ModuleRequestInputModel } from '../model/FormsEntity/moduleRequestInputModel';
import { UserManagementService } from '../service/userManagement.service';
import { ModuleListResponeModel } from '../model/FormsEntity/moduleListResponeModel';
import { MatTooltipModule } from '@angular/material/tooltip';


import { LoaderService } from '../service/loader.service';
import { MatSelectChange } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'dda-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeAnimations],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  isLoading: Subject<boolean> = this.loader.isLoading;

  moduleRequestInputModel: ModuleRequestInputModel = new ModuleRequestInputModel();
  userId: number;
  departmentId: number;
  serviceId: number;
  roleId: number;
  menuUrlList: any[];
  appReady = false;

  disPlayName: any;
  appMenu: ModuleListResponeModel;
  serviceList: ServicesModel[];
  url: any;

  roleName: string;
  visitorCount: number = 371543;
  private defaultFontSize = 16;
  private maxFontSize = 25;
  private minFontSize = 8;
  public currentFontSize = this.defaultFontSize;
  isProd = env.production;
  envName = env.envName;
  version = env.versions.app;
  year = new Date().getFullYear();
  logo = require('../../assets/logo.png');
  languages = ['en', 'hin'];
  navigation = [
    {
      link: 'home',
      label: 'dda.menu.home',
      ariaLabel: 'Go to Home Page',
      style: {
        // Core containment (unchanged)
        width: '120px',
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        display: 'inline-block',


        'min-width': '120px',
        'max-width': '120px',       // Prevents expansion
        'font-size': '14px',        // Fixed size
        'background-color': 'white', // Prevents bleed-through
        'box-sizing': 'border-box',  // Includes padding in width
        'transform': 'scale(1)',     // Neutralizes parent scaling
        'contain': 'size'
      }
    }
  ];

  navigationSideMenu = [
    ...this.navigation,
    {
      link: 'settings',
      label: 'dda.menu.settings',
      style: { /* identical structure */ }
    }
  ];

  isAuthenticated$: Observable<boolean>;
  stickyHeader$: Observable<boolean>;
  language$: Observable<string>;
  theme$: Observable<string>;

  constructor(private route: ActivatedRoute,
    private store: Store,
    private storageService: LocalStorageService,
    public loginService: AuthenticationService,
    private router: Router,
    private userManage: UserManagementService,
    private loader: LoaderService,
    public deptservice: DeptLoginService,
    public translate: TranslateService,
    @Inject(DOCUMENT) private document: Document

  ) {
    let user = sessionStorage.getItem('currentUser');
    if (user != null) {
      const currentUser = this.loginService.currentUserValue;
      this.menuUrlList = currentUser.menuUrl;
      this.serviceList = currentUser.serviceList;
    } else {

    }
  }

  private static isIEorEdgeOrSafari() {
    return ['ie', 'edge', 'safari'].includes(browser().name);
  }
  querystring: any;
  ngOnInit(): void {

    this.incrementVisitorCount();

    this.route.queryParams
      .subscribe(params => {
        console.log(params); // { orderby: "price" }
        this.querystring = params.string;
        //console.log(this.orderby); // price
      }
      );
    if (this.querystring) {

    }

    let user = sessionStorage.getItem('currentUser');
    if (user != null) {
      const currentUser = this.loginService.currentUserValue;
      // console.log(currentUser);
      this.menuUrlList = currentUser.menuUrl;
      this.serviceList = currentUser.serviceList;
    } else {

    }
    this.userManage.getServicesList().subscribe(data => {
      // console.log(data);
    })
    this.storageService.testLocalStorage();
    if (AppComponent.isIEorEdgeOrSafari()) {
      this.store.dispatch(
        actionSettingsChangeAnimationsPageDisabled({
          pageAnimationsDisabled: true
        })
      );
    }

    this.isAuthenticated$ = this.store.pipe(select(selectIsAuthenticated));
    this.stickyHeader$ = this.store.pipe(select(selectSettingsStickyHeader));
    this.language$ = this.store.pipe(select(selectSettingsLanguage));
    this.theme$ = this.store.pipe(select(selectEffectiveTheme));


  }
  reload() {
    window.location.reload();
  }
  get isAdmin() {
    const currentUser = this.loginService.currentUserValue;
    this.roleName = currentUser.roleName;
    return this.roleName === 'Admin';
  }
  onLoginClick() {

  }
  getListOfModule(value) {
    let user = sessionStorage.getItem('currentUser');
    if (user != null) {
      const currentUser = this.loginService.currentUserValue;
      this.moduleRequestInputModel.userId = this.userId = currentUser.userId;
      this.moduleRequestInputModel.departmentId = this.departmentId = currentUser.departmentId;
      this.moduleRequestInputModel.serviceId = this.serviceId = value;
      this.moduleRequestInputModel.roleId = this.roleId = currentUser.roleId;
      this.userManage.getModulesName(this.moduleRequestInputModel).subscribe(data => {
        this.appMenu = data;
        localStorage.setItem('appMenu', JSON.stringify(this.appMenu));
        // console.log(data);
        if (value === 1) {
          this.router.navigate(['/housing']);
        } else if (value === 2) {
          this.router.navigate(['/landDesposal']);
        } else if (value === 3) {
          this.router.navigate(['/personalHearing']);
        } else if (value === 4) {
          this.router.navigate(['/communityHall']);
        } else if (value === 5) {
          this.router.navigate(['/rwa']);
        } else if (value === 6) {
          this.router.navigate(['/sport']);
        }
        else if (value === 7) {
          this.router.navigate(['/alterationFlats']);
        }
      });
    }
  }
  getListOfModuleForAdmin() {
    let user = sessionStorage.getItem('currentUser');
    if (user != null) {
      const currentUser = this.loginService.currentUserValue;
      this.moduleRequestInputModel.userId = this.userId = currentUser.userId;
      this.moduleRequestInputModel.roleId = this.roleId = currentUser.roleId;
      this.userManage.getModulesName(this.moduleRequestInputModel).subscribe(data => {
        this.appMenu = data;
        localStorage.setItem('appMenu', JSON.stringify(this.appMenu));
        this.router.navigate(['/admin']);
      })
    }
  }
  getListOfModuleForMeeting() {
    let user = sessionStorage.getItem('currentUser');
    if (user != null) {
      const currentUser = this.loginService.currentUserValue;
      this.moduleRequestInputModel.userId = this.userId = currentUser.userId;
      this.moduleRequestInputModel.roleId = this.roleId = currentUser.roleId;
      this.moduleRequestInputModel.departmentId = currentUser.departmentId;
      this.userManage.getModulesName(this.moduleRequestInputModel).subscribe(data => {
        this.appMenu = data;
        localStorage.setItem('appMenu', JSON.stringify(this.appMenu));
        this.router.navigate(['/meetingSchedule']);
      })
    }
  }


  onLogoutClick() {
    this.loginService.logOut();
    this.menuUrlList = null;
    this.serviceList = null;
    localStorage.removeItem('appMenu');
    this.router.navigate(['/']);
  }


  language = 'en';

  onLanguageSelect(event: MatSelectChange) {
    const selectedLanguage = event.value;

    if (selectedLanguage === this.language) return;

    const confirmed = window.confirm('Are you sure you want to change the language?');

    if (confirmed) {
      this.language = selectedLanguage;

      // ✅ Change <html lang="...">
      this.document.documentElement.lang = selectedLanguage;

      // ✅ Optional: update meta tag too
      const metaLang = this.document.querySelector('meta[name="lang"]');
      if (metaLang) {
        metaLang.setAttribute('content', selectedLanguage === 'hin' ? 'Hindi' : 'English');
      }

      // Dispatch to store if needed
      this.store.dispatch(actionSettingsChangeLanguage({ language: selectedLanguage }));
    } else {
      setTimeout(() => {
        event.source.writeValue(this.language);
      });
    }
  }

  DeptLogin() {
    this.deptservice.Geteparichayurl().subscribe(data => {
      if (data) {
        console.log(data.body.status.detailMessage)
        // this.router.navigate([data.body.status.detailMessage])
        window.location.href = data.body.status.detailMessage
      }
    })


  }
  today: Date = new Date();


  incrementVisitorCount(): void {
    const countKey = 'visitorCount';
    let storedCount = localStorage.getItem(countKey);

    if (storedCount) {
      this.visitorCount = parseInt(storedCount) + 1;
    } else {
      this.visitorCount = 371543 + 1;
    }

    localStorage.setItem(countKey, this.visitorCount.toString());
  }






  increaseFontSize() {
    if (this.currentFontSize < this.maxFontSize) {
      this.currentFontSize += 2;
      this.updateFontSize();
    }
  }

  decreaseFontSize() {
    if (this.currentFontSize > this.minFontSize) {
      this.currentFontSize -= 2;
      this.updateFontSize();
    }
  }

  resetFontSize() {
    this.currentFontSize = this.defaultFontSize;
    this.updateFontSize();
  }

  updateFontSize() {
    document.documentElement.style.setProperty('--base-font-size', this.currentFontSize + 'px');
  }


  confirmRedirect(url: string): void {
    const confirmResult = confirm('You are being redirected to an external website. Please note that DDA cannot be held responsible for external websites content & privacy policies.');
    if (confirmResult) {
      window.open(url, '_blank');
    }
  }


  skipToMainContent(): void {
    const mainContent = document.getElementById('main-content');
    const mainHeader = document.querySelector('mat-toolbar') as HTMLElement;
    let lastScrollTop = 0;

    if (mainContent) {
      // Scroll into view
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }

    if (mainHeader) {
      // Add CSS class for transition effect (only once)
      mainHeader.classList.add('scroll-toolbar');
    }

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop) {
        // Scrolling Down → Hide Header
        if (mainHeader) {
          mainHeader.style.transform = 'translateY(-100%)';
        }
      } else {
        // Scrolling Up → Show Header AND REFRESH PAGE
        if (mainHeader) {
          mainHeader.style.transform = 'translateY(0)';
        }
        window.location.reload(); // Auto-refresh on scroll-up
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });
  }

  searchQuery: string = '';
  onSearch(): void {
    const query = this.searchQuery?.trim();

    if (!query) {
      alert('Please enter something to search');
      return;
    }


    this.router.navigate(['/sitemap'], { queryParams: { q: query } }).then(() => {

      this.searchQuery = '';
    });
  }



  confirmAndRedirect(event: Event, url: string) {
    event.preventDefault(); // Prevent immediate navigation

    const confirmOpen = confirm('Are you sure you want to open this link?');
    if (confirmOpen) {
      window.open(url, '_blank');
    }
  }

  handleClick(event: Event, url: string) {
    event.preventDefault();

    const confirmed = confirm("Are you sure you want to open this link?");
    if (confirmed) {
      window.open(url, '_blank');
    }
  }

  icons = [
    { name: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/ddaofficial' },
    { name: 'instagram', label: 'Instagram', url: 'https://instagram.com/official_dda_?igshid=MDM4ZDc5MmU=' },
    { name: 'twitter', label: 'Twitter', url: 'https://twitter.com/official_dda?t=fUiTefC3v90pvsWEz_qfnQ&s=08' },
    { name: 'youtube', label: 'YouTube', url: 'https://youtube.com/@DelhiDevelopmentAuthorityLive' }
  ];


  footerLinks = [
    { route: '/contentarchival', label: 'Content Archival Policy', ariaLabel: 'Content Archival Policy' },
    { route: '/contentreview', label: 'Copyright Review Policy', ariaLabel: 'Copyright Review Policy' },
    { route: '/camp', label: 'Content Contribution Moderation and Approval', ariaLabel: 'Content Contribution Moderation and Approval' },
    { route: '/website-monitor', label: 'Website Monitoring', ariaLabel: 'Website Monitoring' },
    { route: '/security', label: 'Website Security Policy', ariaLabel: 'Website Security Policy' },
    { route: '/contingency', label: 'Contingency Mangement Plan', ariaLabel: 'Contingency Management Plan' },
    { route: '/copyrigth', label: 'Copyright Policy', ariaLabel: 'Copyright Policy' },
    { route: '/termcondition', label: 'Terms & Conditions', ariaLabel: 'Terms and Conditions' },
    { route: '/privacy', label: 'Privacy Policy', ariaLabel: 'Privacy Policy' },
    { route: '/disclamer', label: 'Disclaimer', ariaLabel: 'Disclaimer' },
    { route: '/hyperlink', label: 'Hyperlinking Policy', ariaLabel: 'Hyperlinking Policy' },
    { route: '/webinfo', label: 'Web Information Manager', ariaLabel: 'Web Information Manager' },
    { route: '/sitemap', label: 'SiteMap', ariaLabel: 'Site Map' },
    { route: '/help', label: 'Help', ariaLabel: 'Help' },
    { route: '/feedback', label: 'Feedback', ariaLabel: 'Feedback' },
    { route: '/contactus', label: 'dda.menu.contactUs', ariaLabel: 'Contact Us' },
    { route: '/faqs', label: 'FAQS', ariaLabel: 'Frequently Asked Questions' }
  ];



}


















